import { vueAuth } from "../services/auth";
import { $routerRef } from "..";
import { usersApi } from "@/services/api/user.api";
import { appTitle } from "@/constants";

export default {
  state: {
    currentUser: null,
    error: "",
    loading: false
  },
  mutations: {
    AUTHENTICATION_ERROR(state: any, payload: any) {
      state.error = payload;
    },
    SET_AUTHENTICATED(state: any, payload: any) {
      state.error = "";
    },
    SET_CURRENTUSER(state: any, payload: any) {
      state.error = "";
      state.currentUser = payload.user;
      state.currentRoles = payload.roles;
    },

    LOGIN_STARTED(state: any) {
      state.loading = true;
    },

    LOGIN_FINISHED(state: any) {
      state.loading = false;
    }
  },
  actions: {
    login(context: any, payload: any) {
      context.commit("LOGIN_STARTED");
      vueAuth
        .login(payload.user)
        .then(response => {
          context.commit("SET_AUTHENTICATED");
          const usrObj = {usr: response.data.userId, unit: appTitle};
          localStorage.setItem("qlm-user", JSON.stringify(usrObj));
          // context.dispatch("getCurrentUser", response.data.userId);
          $routerRef.replace("/");
        })
        .catch((error: any) => {
          context.commit("AUTHENTICATION_ERROR", error.response.data);
        })
        .finally(() => {
          context.commit("LOGIN_FINISHED");
        });
    },

    logout(context: any, payload: any) {
      vueAuth.logout().then(() => {
        localStorage.removeItem("qlm-user");
        context.commit("SET_CURRENTUSER", {
          user: undefined,
          roles: undefined
        });
        $routerRef.replace("login");
      }).catch((err) => {
        // console.error(err);
      });
    },
    getCurrentUser(context: any, payload: any) {
      usersApi
        .getCurrentUser()
        .then((response: any) => {
          context.commit("SET_CURRENTUSER", response.data);
        })
        .catch(() => {
          // -
        });
    }
  },
  getters: {
    isAuthenticated() {
      return vueAuth.isAuthenticated();
    },
    currentUser(state) {
      return state.currentUser;
    },
    currentRoles(state) {
      return state.currentRoles;
    }
  }
};
